import { straightLineIcon } from "assets/icons";

export const cardsContainer = `
  background-color: ${({ theme }) => theme.global.bg.quaternary};
  border-radius: 10px;
`;

export const cardTitle = `
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  color: ${({ theme }) => theme.global.extraInfo.font.color};
`;

export const footerDescription = `
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.global.color.quaternary};
`;

export const flexColumnCenter = `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const filterBox = `
  cursor: pointer;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 1px solid #4a4c55;
  margin-top: 5px;
`;

export const sliderBarHeight = `
  height: 6px;
`;

export const dottedLine = `
  content: "";
  display: block;
  background: url("${straightLineIcon}") no-repeat top right;
  width: 13px;
  height: 60px;
`;

export const conditionButton = `
  border: 1px solid rgba(255, 255, 255, 0.5);
  background-color: transparent;
  border-radius: 5px;
  padding: 3px 10px;
  font-weight: 400;
  font-size: 15px;
`;
